var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "alerts-messages-container" },
    [
      _setup.ListStatus.LOADING === _setup.status
        ? _c(_setup.SpinnerLayerComponent, { staticClass: "list-spinner" })
        : _vm._e(),
      _setup.ListStatus.OK === _setup.status
        ? [
            _c("div", { staticClass: "selector-container" }, [
              _c(
                "div",
                { staticClass: "select-container" },
                [
                  _c("v-spacer"),
                  _c(_setup.LexonSelectComponent, {
                    staticClass: "lf-select",
                    attrs: {
                      keyName: "text",
                      keyValue: "value",
                      propItems: _setup.orderTypeItems,
                      clearable: false,
                      showSearch: false,
                    },
                    on: { input: (e) => _setup.onOrderChange(e.value) },
                    model: {
                      value: _setup.selectedOrderItem,
                      callback: function ($$v) {
                        _setup.selectedOrderItem = $$v
                      },
                      expression: "selectedOrderItem",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(_setup.AlertsMessagesListComponent, {
              attrs: { alerts: _setup.filteredList.data },
            }),
            _c(
              "div",
              { staticClass: "paginator-container" },
              [
                _c(_setup.ServerPaginationComponent, {
                  attrs: {
                    currentPage: _setup.numPage,
                    totalRegisters: _setup.filteredList.pagination.totalRecs,
                  },
                  on: { "change-page": _setup.onPageChanged },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _setup.ListStatus.EMPTY === _setup.status
        ? _c("section", { staticClass: "no-data-container" }, [
            _c("span", {
              class: [_setup.noDataIcon, "lf-icon__xl", "no-data-icon"],
            }),
            _c(
              "div",
              { staticClass: "texts" },
              [
                _c("p", { staticClass: "no-data-text" }, [
                  _vm._v(_vm._s(_setup.texts.noData)),
                ]),
                _c("i18n", {
                  staticClass: "link-text",
                  attrs: { path: _setup.path, tag: "div" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "link",
                        fn: function () {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "actions-link",
                                attrs: { to: _setup.alertConfigPanelURL },
                              },
                              [_vm._v(_vm._s(_setup.texts.link))]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    493502959
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _setup.ListStatus.ERROR === _setup.status
        ? _c("section", { staticClass: "no-data-container" }, [
            _c("span", {
              class: [_setup.errorIcon, "lf-icon__xl", "no-data-icon"],
            }),
            _c("div", { staticClass: "texts" }, [
              _c("p", { staticClass: "no-data-text" }, [
                _vm._v(_vm._s(_setup.texts.loadError)),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }